import { render } from "./DocumentSearchMask.vue?vue&type=template&id=106920e2&scoped=true&ts=true"
import script from "./DocumentSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentSearchMask.vue?vue&type=script&lang=ts"

import "./DocumentSearchMask.vue?vue&type=style&index=0&id=106920e2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106920e2"]])

export default __exports__